module.exports = __webpack_public_path__ + "img/icons for DS Logistik SPIM.-09.7daf0a41.svg";